import { useNavigate, useSearchParams } from 'react-router-dom'
import { INTEGRATIONS } from '@super/shared-types'
import { ROUTE_REGISTRY } from '@/lib/routes'
import { FloatingActionIslandProvider } from '@/contexts/FloatingActionIslandContext'
import { FloatingActionIsland } from '@/components/ui/FloatingActionIsland'
import { Heading } from '@/components/ui/typography'
import { AppFolioConnectForm } from '@/components/integrations/vendors/AppFolioConnectForm'

/**
 * Page chrome only. The form body lives in AppFolioConnectForm and is mounted
 * unchanged by both this page and the onboarding sub-page.
 */
export function AppFolioIntegrationPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isEditMode = searchParams.get('mode') === 'edit'

  return (
    <div className="h-full pt-16">
      <FloatingActionIslandProvider>
        <div className="space-y-6 p-6 pt-0 pb-24">
          <div className="flex items-center gap-3 mt-6">
            <div className="w-10 h-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden">
              <img
                src={INTEGRATIONS.APPFOLIO.LOGO_PATH}
                alt={INTEGRATIONS.APPFOLIO.NAME}
                className="w-full h-full object-contain"
              />
            </div>
            <Heading variant="subsection-title">
              {isEditMode ? 'Update' : 'Connect'} {INTEGRATIONS.APPFOLIO.NAME}
            </Heading>
          </div>

          <AppFolioConnectForm
            isEditMode={isEditMode}
            onConnected={() =>
              navigate(ROUTE_REGISTRY.SETTINGS_INTEGRATIONS.path)
            }
          />
        </div>
        <FloatingActionIsland />
      </FloatingActionIslandProvider>
    </div>
  )
}
